/*
 * Marelle — due cose che il tema da solo non fa.
 *
 * 1) ANCORAGGIO AL MERCATO ITALIANO
 *    Lo store ha più mercati attivi e Shopify li assegna dall'IP del
 *    visitatore. Su ogni mercato diverso da IT il catalogo NON è vendibile:
 *    `/cart/add.js` risponde 422 "Il prodotto ... è già esaurito" e il tema
 *    mostra quel messaggio al posto del carrello. In più i prezzi arrivano
 *    convertiti (es. 215,00 RON) ma il tema stampa il simbolo € fisso, quindi
 *    il visitatore legge "215,00 €" su un capo da 39,90 €.
 *    ⚠️ È la rete di sicurezza, non la cura: il rimedio vero è nell'admin
 *    Shopify — togliere il mercato di troppo o metterci dentro il prodotto.
 *
 * 2) CHECKOUT SCALDATO IN ANTICIPO
 *    Al click su "Vai al pagamento sicuro" il ponte deve, in fila: aprire la
 *    connessione a checkout.marelle.store (DNS + TLS, su 4G sono centinaia di
 *    ms), farsi creare il carrello, e solo allora navigare. Tutto questo mentre
 *    il cliente guarda una rotella. Qui lo si anticipa a quando il cliente sta
 *    ancora leggendo la scheda: si aprono le connessioni e si tiene sveglia la
 *    funzione del checkout (la GET su /api/cart/create è il ping documentato,
 *    non crea niente). Al click resta solo il viaggio utile.
 */
(function () {
  'use strict';

  var CHECKOUT = 'https://checkout.marelle.store';
  var TARGET = 'IT';
  var KEY = 'eta_mkt_' + TARGET;
  var MAX = 2; // due tentativi per sessione, poi si lascia stare: mai un ciclo di reload

  /* ---------------- 1. mercato ---------------- */

  function letti() {
    try { return parseInt(sessionStorage.getItem(KEY), 10) || 0; } catch (e) { return MAX; }
  }
  function segna(n) {
    try { sessionStorage.setItem(KEY, String(n)); } catch (e) {}
  }

  function pin() {
    var S = window.Shopify;
    if (!S || !S.country) return false;                                  // contesto non disponibile
    if (String(S.country).toUpperCase() === TARGET) { segna(0); return false; }  // già a posto

    var n = letti();
    if (n >= MAX) return false;
    segna(n + 1);

    var f = document.createElement('form');
    f.method = 'post';
    f.action = '/localization';
    f.style.display = 'none';
    [
      ['form_type', 'localization'],
      ['utf8', '✓'],
      ['_method', 'put'],
      ['country_code', TARGET],
      ['return_to', location.pathname + location.search],
    ].forEach(function (kv) {
      var i = document.createElement('input');
      i.type = 'hidden';
      i.name = kv[0];
      i.value = kv[1];
      f.appendChild(i);
    });
    (document.body || document.documentElement).appendChild(f);
    f.submit();
    return true; // si sta navigando: inutile scaldare questa pagina
  }

  /* ---------------- 2. prericaldo ---------------- */

  function hint(rel, href, cors) {
    try {
      var l = document.createElement('link');
      l.rel = rel;
      l.href = href;
      if (cors) l.crossOrigin = '';
      (document.head || document.documentElement).appendChild(l);
    } catch (e) {}
  }

  function scalda() {
    // DNS + TLS verso il checkout e verso l'origine del riquadro di pagamento,
    // così al click non si paga l'handshake.
    hint('dns-prefetch', CHECKOUT);
    hint('preconnect', CHECKOUT, true);
    hint('dns-prefetch', 'https://whop.com');
    hint('preconnect', 'https://whop.com', true);

    // Ping di keep-warm: nessun effetto collaterale, tiene su la funzione e la
    // connessione al database. Una sola volta per pagina, e solo dove il
    // cliente può davvero comprare.
    try {
      fetch(CHECKOUT + '/api/cart/create', { method: 'GET', mode: 'no-cors', cache: 'no-store', credentials: 'omit' }).catch(function () {});
    } catch (e) {}
  }

  function avvia() {
    if (pin()) return;
    scalda();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia);
  } else {
    avvia();
  }
})();
